import {
	EmailImportance,
	ExchangeEmailId,
	ExchangeFolderId,
	ExchangeMessageBodyKind,
	MailMessageLocationModel,
	MailMessageLocationQueryModel
} from "./common";
import { environmentHttpClient } from "client/Api/httpClient";

export interface DraftEmailModel {
	exchangeId: ExchangeEmailId;
	to: string;
	cc: string;
	bcc: string;
	subject: string | null;
	fromAddress: string | null;
	bodyType: ExchangeMessageBodyKind;
	body: string | null;
	size: number;
	emailAttachments: DraftEmailAttachment[];
	importance?: EmailImportance;
	parentFolderId: ExchangeFolderId;
}

export type NewDraftEmailModel = Omit<DraftEmailModel, "parentFolderId"> & { parentFolderId: null; };

export interface DraftEmailAttachment {
	id: string;
	name: string;
	size: number;
	isInline: boolean;
	contentId: string;
}

export interface SendOrSaveEmailDraftModel {
	exchangeId: ExchangeEmailId;
	smtpAddress: OptionalModel<string>;
	fromAddress: string;
	to: string;
	cc: string;
	bcc: string;
	subject: string;
	body: string;
	importance: EmailImportance;
}

function acceptMeetingInvitation(message: MailMessageLocationModel, sendResponse: boolean): Promise<void> {
	return environmentHttpClient.post<void>(
		"Email/AcceptMeetingInvitation",
		{
			message,
			sendResponse
		}
	);
}

function declineMeetingInvitation(message: MailMessageLocationModel, sendResponse: boolean): Promise<void> {
	return environmentHttpClient.post<void>(
		"Email/DeclineMeetingInvitation",
		{
			message,
			sendResponse
		}
	);
}

function prepareExchangeEmailForForward(
	source: MailMessageLocationQueryModel,
	utcOffset: string
): Promise<DraftEmailModel> {
	return environmentHttpClient.get<DraftEmailModel>(
		"Email/PrepareExchangeEmailForForward",
		{
			smtpAddress: source.smtpAddress,
			messageId: source.messageId,
			utcOffset
		}
	);
}

function prepareExchangeEmailForReply(
	source: MailMessageLocationQueryModel,
	utcOffset: string
): Promise<DraftEmailModel> {
	return environmentHttpClient.get<DraftEmailModel>(
		"Email/PrepareExchangeEmailForReply",
		{
			smtpAddress: source.smtpAddress,
			messageId: source.messageId,
			utcOffset
		}
	);
}

function prepareExchangeEmailForReplyAll(
	source: MailMessageLocationQueryModel,
	utcOffset: string
): Promise<DraftEmailModel> {
	return environmentHttpClient.get<DraftEmailModel>(
		"Email/PrepareExchangeEmailForReplyAll",
		{
			smtpAddress: source.smtpAddress,
			messageId: source.messageId,
			utcOffset
		}
	);
}

export {
	prepareExchangeEmailForForward,
	prepareExchangeEmailForReply,
	prepareExchangeEmailForReplyAll,
	acceptMeetingInvitation,
	declineMeetingInvitation,
};
